import { useCallback, useEffect, useState } from 'react';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { Offcanvas } from 'react-bootstrap';
import { Flex, View, Link, DialogContainer, Dialog, Content, Header } from '@adobe/react-spectrum';
import { Plus, Pen } from 'react-bootstrap-icons';
import { FilterIcon } from '../../../../components/protected/Icons/IconsLib';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { useTranslation } from 'react-i18next';
import styles from './filter_component.module.css';
import ItemTypeFilterComponent from './ItemTypeFilterComponent';
import FilterProductCode from './FilterProductCode';
import FPAListDropDown from './FPAListDropDown';
import ItemStatusFilterComponent from './ItemStatusFilterComponent';
import { useDeviceDetection } from '../../../../hooks/UseDeviceDetection';

interface IFilterComponentProps {
  onFilterChange: (filterParams: {}) => void;
  filterParams: any;
  filterStyle?: any;
  priceList?: any[];
}

const FilterComponent: React.FC<IFilterComponentProps> = ({ onFilterChange, filterParams, filterStyle, priceList }) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_filters.${key}`, { ns: 'products' });
  const { isMobile } = useViewInfo();
  const [show, setShow] = useState(false);
  const [selectedView, setSelectedView] = useState<string>(filterParams?.FILTER.COL.find((col: any) => col.name === 'state')?.value || 'All views');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [clearFilters, setClearFilters] = useState<boolean>(false);
  const [selectedFolder, setSelectedFolder] = useState<string>("");
  const deviceInfo = useDeviceDetection(isMobile);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setSelectedView(filterParams?.FILTER.COL.find((col: any) => col.name === 'state')?.value || 'All views');
  };


  const createParams = useCallback(
    async (filterTypeName: any, filterValue: any) => {
      //initializeFilterParams();
      const filterValueStr =
        filterTypeName === "contactType"
          ? filterValue
          : Array.from(filterValue).join(",");
      if (
        (filterTypeName == "type" && filterValueStr == "All types") ||
        (filterTypeName == "manufacturer" && filterValueStr == "") ||
        (filterTypeName == "product_code" && filterValueStr == "") ||
        (filterTypeName == "status" && filterValueStr == "All status")
      ) {
        filterParams.FILTER.COL = [];
        onFilterChange(filterParams);
        return;
      }
      handleFilterType(filterTypeName, filterValueStr, filterValue);
    },
    [selectedApp]
  );

  const updateFilterParams = (name: string, value: string) => {
    let updatedArray = filterParams.FILTER.COL.map((obj: any) =>
      obj.name === name ? { ...obj, value } : obj
    );
    const hasNameSearch = filterParams.FILTER.COL.some(
      (obj: any) => obj.name === name
    );

    if (!hasNameSearch) {
      updatedArray.push({ name, value });
    }
    filterParams.FILTER.COL = updatedArray;
  };
  const handleFilterType = (
    filterTypeName: any,
    filterValueStr: any,
    filterValue: any
  ) => {
    switch (filterTypeName) {
      case "type":
        updateFilterParams("type", filterValueStr);
        break;
      case "manufacturer":
        updateFilterParams("manufacturer", filterValue);
        break;
      case "product_code":
        updateFilterParams("product_code", filterValue);
        break;
      case "status":
        updateFilterParams("status", filterValueStr);
        break;
      default:
        break;
    }

    filterParams.FILTER.COL = filterParams.FILTER.COL.filter(
      (col: any) => col.value !== ""
    );
    onFilterChange(filterParams);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setTimeout(() => setClearFilters(false), 0);
  };

  const shouldUseMobileLayout = deviceInfo.shouldUseMobileLayout();
  const isMobileOrSmallScreen =
    shouldUseMobileLayout || deviceInfo.isIPad || deviceInfo.isTablet;

  return isMobileOrSmallScreen ? (
    <View position={'relative'} width={'100%'} height={'64px'} UNSAFE_className={styles.mobile_header_parent}>
      <Flex direction={'column'} position={'absolute'} top={'calc(50% - 16px)'} left={'20px'} align-items={'start'} justifyContent={'start'}>
        <View position={'relative'} UNSAFE_className={styles.mobile_header_text_1}>
          {/* {selectedView === 'All views'
          ? t('all_service_activities', { ns: 'layout_components' })
          : selectedView === '1,2'
          ? t('my_service_activities', { ns: 'layout_components' })
          : t('today_service_activities', { ns: 'layout_components' })} */}
          {_t("header_text")}
        </View>
        {/* <View position={'relative'} UNSAFE_className={styles.mobile_header_text_2}>
        {t('service_activities', { ns: 'layout_components' })}
      </View> */}
      </Flex>
      <View position={'absolute'} top={'calc(50% - 12px)'} left={'16px'} width={'24px'} height={'24px'} overflow={'hidden'}>
        <span onClick={handleShow} className="me-2">
          <i className="bi bi-list"></i>
        </span>
        <Offcanvas show={show} onHide={handleClose} placement="start">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Flex
              direction={'column'}
              position={'absolute'}
              top={'50px'}
              left={'15px'}
              width={'240px'}
              alignItems={'start'}
              justifyContent={'start'}
              gap={'5px'}
              UNSAFE_className={styles.views_menu_container}
            >
              <Flex direction={'row'} UNSAFE_className={styles.views_menu_heading} alignSelf={'stretch'} alignItems={'center'} justifyContent={'start'}>
                <View position={'relative'} UNSAFE_className={styles.menu_heading_text}>
                  PriceList Views
                </View>
              </Flex>
              <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'4px'} UNSAFE_className={styles.filter_views_parent}>
                {priceList && priceList.length > 0 &&
                  <>
                    {priceList.map((item, index) => (
                      <>
                        <a
                          onClick={() => {
                            setSelectedView(item.id);
                            createParams('currency', item.id);
                          }}
                        >
                          <Flex UNSAFE_className={selectedView === item.id ? styles.filter_views_container_selected : styles.filter_views_container}>
                            <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
                              <Flex position={'relative'} flex={1} UNSAFE_className={styles.filter_views_text}>
                                {/* {t('today_service_activities', { ns: 'layout_components' })} */}
                                {item.name}
                              </Flex>
                            </Flex>
                          </Flex>
                        </a>
                      </>

                    ))}
                  </>
                }
              </Flex>
            </Flex>
            {/* <View position={'relative'} top={'85%'} width={'100%'} height={'1px'} UNSAFE_className={styles.separator}>
            <Flex direction={'column'} position={'absolute'} width={'240px'} alignItems={'start'} justifyContent={'start'} gap={'5px'} UNSAFE_className={styles.views_menu_container}>
              <Flex direction={'column'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.button_group_parent}>
                <Flex position={'relative'} width={'266px'} height={'56px'} flexShrink={0} UNSAFE_className={styles.button_group_wrapper}>
                  <Flex direction={'row'} position={'absolute'} top={'calc(50% - 10px)'} left={'14px'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.btn_style}>
                    <Link
                      isQuiet
                      onPress={() => {
                      }}
                    >
                      <>
                        <Plus fontSize={'25px'} />
                        {t('add_view', { ns: 'layout_components' })}
                      </>
                    </Link>
                  </Flex>
                </Flex>
                <Flex position={'relative'} width={'266px'} height={'56px'} flexShrink={0} UNSAFE_className={styles.button_group_wrapper}>
                  <Flex direction={'row'} position={'absolute'} gap={'8px'} top={'calc(50% - 10px)'} left={'14px'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.btn_style}>
                    <Link
                      isQuiet
                      onPress={() => {
                      }}
                    >
                      <>
                        <Pen />
                        {t('edit_view', { ns: 'layout_components' })}
                      </>
                    </Link>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </View> */}
          </Offcanvas.Body>
        </Offcanvas>
      </View>

      <View position={'absolute'} top={'calc(50% - 12px)'} left={'calc(100% - 40px)'} width={'24px'} height={'24px'} overflow={'hidden'}>
        <div onClick={() => setIsOpen(true)}>
          <FilterIcon size={20} />
        </div>

        <DialogContainer
          isDismissable
          onDismiss={() => {
            setIsOpen(false);
          }}
        >
          {isOpen && (
            <Dialog size="L">
              <Content>
                <Header>
                  <Flex position={'relative'} direction={'row'} justifyContent={'center'} alignContent={'center'} width={'100%'}>
                    <View position={'relative'} UNSAFE_className={styles.popup_header_text}>
                      {t('filters', { ns: 'layout_components' })}
                    </View>
                  </Flex>
                </Header>
                <View width={'100%'} position={'relative'} height={'100vh'}>
                  <Flex
                    direction={'column'}
                    position={'absolute'}
                    width={'95%'}
                    top={'30px'}
                    left={'16px'}
                    alignItems={'start'}
                    justifyContent={'start'}
                    gap={'24px'}
                    UNSAFE_className={styles.popup_header_body_parent}
                  >
                    <Flex direction={'column'} width={'100%'} alignItems={'start'} justifyContent={'start'} gap={'12px'} UNSAFE_className={styles.popup_header_body}>
                      <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'4px'} UNSAFE_className={styles.filter_views_parent}>
                        {priceList && priceList.length > 0 &&
                          <>
                            {priceList.map((item, index) => (
                              <>
                                <a
                                  onClick={() => {
                                    setSelectedView(item.id);
                                    createParams('currency', item.id);
                                  }}
                                >
                                  <Flex UNSAFE_className={selectedView === item.id ? styles.filter_views_container_selected : styles.filter_views_container}>
                                    <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
                                      <Flex position={'relative'} flex={1} UNSAFE_className={styles.filter_views_text}>
                                        {/* {t('today_service_activities', { ns: 'layout_components' })} */}
                                        {item.name}
                                      </Flex>
                                    </Flex>
                                  </Flex>
                                </a>
                              </>

                            ))}
                            <View position={'relative'} width={'100%'} height={'20px'} UNSAFE_className={styles.activity_type_clear_all_container}>
                              <View position={'relative'} UNSAFE_className={styles.activity_type_clear_all_text}>
                                <Link onPress={() => {
                                  createParams('view', new Set(['All currencies']))
                                  setSelectedView('All currencies')
                                }}>{_t('clear_all')}</Link>
                              </View>
                            </View>
                          </>
                        }

                      </Flex>
                      <FilterProductCode createParams={createParams} filterParams={filterParams} clearFilters={clearFilters} />
                      <FPAListDropDown
                        selectedFolder={selectedFolder}
                        onChange={(data) => {
                          const { id, name } = data;
                          createParams('manufacturer', id);
                          setSelectedFolder(id);
                        }}
                      />
                      <ItemStatusFilterComponent createParams={createParams} filterParams={filterParams} />
                      <ItemTypeFilterComponent createParams={createParams} clearFilters={clearFilters} />
                    </Flex>
                  </Flex>
                </View>
              </Content>
            </Dialog>
          )}
        </DialogContainer>
      </View>
    </View>
  ) : (
    <View width={'100%'} position={'relative'} backgroundColor={'static-white'} UNSAFE_className={styles.filter_menu_parent} UNSAFE_style={filterStyle}>
      <Flex direction={'column'} position={'relative'} top={'24px'} left={'0px'} width={'240px'} alignItems={'start'} justifyContent={'start'} gap={'5px'} UNSAFE_className={styles.views_menu_container}>
        <Flex direction={'row'} UNSAFE_className={styles.views_menu_heading} alignSelf={'stretch'} alignItems={'center'} justifyContent={'start'}>
          <View position={'relative'} UNSAFE_className={styles.menu_heading_text}>
            {priceList && priceList.length > 0 && t('views', { ns: 'layout_components' })}
          </View>
        </Flex>
        <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'4px'} UNSAFE_className={styles.filter_views_parent}>
          {priceList && priceList.length > 0 &&
            <>
              {priceList.map((item, index) => (
                <>
                  <a
                    onClick={() => {
                      setSelectedView(item.id);
                      createParams('currency', item.id);
                    }}
                  >
                    <Flex UNSAFE_className={selectedView === item.id ? styles.filter_views_container_selected : styles.filter_views_container}>
                      <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
                        <Flex position={'relative'} flex={1} UNSAFE_className={styles.filter_views_text}>
                          {/* {t('today_service_activities', { ns: 'layout_components' })} */}
                          {item.name}
                        </Flex>
                      </Flex>
                    </Flex>
                  </a>
                </>

              ))}
              <View position={'relative'} width={'100%'} height={'20px'} UNSAFE_className={styles.activity_type_clear_all_container}>
                <View position={'relative'} UNSAFE_className={styles.activity_type_clear_all_text}>
                  <Link onPress={() => {
                    createParams('view', new Set(['All currencies']))
                    setSelectedView('All currencies')
                  }}>{_t('clear_all')}</Link>
                </View>
              </View>
            </>
          }

        </Flex>
      </Flex>
      {priceList && priceList.length > 0 && (
        <Flex position={'relative'} top={'30px'}>
          <View width={'100%'} height={'1px'} UNSAFE_className={styles.separator}></View>
        </Flex>
      )}
      <Flex
        direction={'column'}
        position={'relative'}
        top={priceList && priceList.length > 0 ? '40px' : '0px'}
        left={'0px'}
        width={'240px'}
        alignItems={'start'}
        justifyContent={'start'}
        gap={'5px'}
        UNSAFE_className={styles.filters_menu_container}
      >
        <Flex direction={'row'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.filters_menu_wrapper}>
          <View position={'relative'} UNSAFE_className={styles.menu_heading_text}>
            {t('filters', { ns: 'layout_components' })}
          </View>
        </Flex>
        {/* <ActivityStatusFilterComponent createParams={createParams} filterParams={filterParams} /> */}
        {/* <UsersFilterComponent createParams={createParams} filterParams={filterParams} /> */}
        <FilterProductCode createParams={createParams} filterParams={filterParams} clearFilters={clearFilters} />
        {/* <ActivityTypeFilterComponent createParams={createParams} filterParams={filterParams} /> */}
        <FPAListDropDown
          selectedFolder={selectedFolder}
          onChange={(data) => {
            const { id, name } = data;
            createParams('manufacturer', id);
            setSelectedFolder(id);
          }}
        />
        <ItemStatusFilterComponent createParams={createParams} filterParams={filterParams} />
        <ItemTypeFilterComponent createParams={createParams} clearFilters={clearFilters} />
      </Flex>
    </View>
  );
};

export default FilterComponent;
